import { Box, Link } from "@mui/material";
import NextLink from "next/link";

const ArticleDoi = ({ articleDoi }: { articleDoi: string }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      minWidth: 0,
    }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: 25,
        mr: 0.25
      }}>
      <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130 130"
        sx={{
          width: "25",
          height: "25"
        }}>
        <Box
          component="circle"
          style={{ fill: "#fcb425" }}
          cx="65"
          cy="65"
          r="64"
        />
        <Box
          component="path"
          style={{ fill: "#231f20" }}
          d="M49.819127 84.559148h-11.854304v-4.825665c-1.203594 1.510894-4.035515 3.051053-5.264716 3.742483-2.151101 1.203585-5.072066 1.987225-7.812161 1.987225-4.430246 0-8.373925-1.399539-11.831057-4.446924-4.122946-3.636389-6.060246-9.19576-6.060246-15.188113 0-6.094791 2.112691-10.960381 6.338064-14.59676 3.354695-2.893745 7.457089-5.209795 11.810505-5.209795 2.535231 0 5.661807 0.227363 7.889738 1.302913 1.280414 0.614601 3.572628 2.060721 4.929872 3.469179v-25.420177h11.854304zm-12.1199-18.692584c0-2.253538-0.618258-4.951555-2.205973-6.513663-1.587724-1.587724-4.474153-2.996182-6.727691-2.996182-2.509615 0-4.834476 1.825511-6.447807 3.720535-1.306031 1.536501-1.959041 3.905269-1.959041 5.877114 0 1.971835 0.740815 4.165004 2.046836 5.701505 1.587714 1.895025 3.297985 3.193739 5.833216 3.193739 2.279145 0 4.989965-0.956662 6.552083-2.51877 1.587714-1.562108 2.908377-4.185134 2.908377-6.464278z"
        />
        <Box
          component="path"
          style={{ fill: "#fff" }}
          d="M105.42764 25.617918c-1.97184 0-3.64919.69142-5.03204 2.074271-1.357247 1.357245-2.035864 3.021779-2.035864 4.993633 0 1.971835.678617 3.649193 2.035864 5.032034 1.38285 1.382861 3.0602 2.074281 5.03204 2.074281 1.99744 0 3.67479-.678627 5.03203-2.035861 1.38285-1.382861 2.07428-3.073012 2.07428-5.070454 0-1.971854-.69143-3.636388-2.07428-4.993633-1.38285-1.382851-3.0602-2.074271-5.03203-2.074271zM74.219383 45.507921c-7.323992 0-12.970625 2.283009-16.939921 6.848949-3.277876 3.782438-4.916803 8.118252-4.916803 13.008406 0 5.430481 1.626124 10.009834 4.878383 13.738236 3.943689 4.538918 9.475093 6.808622 16.59421 6.808622 7.093512 0 12.612122-2.269704 16.555801-6.808622 3.252259-3.728402 4.878393-8.1993 4.878393-13.413648 0-5.160323-1.638938-9.604602-4.916803-13.332994-4.020509-4.56594-9.398263-6.848949-16.13326-6.848949zm24.908603 1.386686v37.634676h12.599304v-37.634676h-12.599304zm-25.292731 11.46806c2.304752 0 4.263793.852337 5.877124 2.554426 1.638928 1.675076 2.458402 3.727881 2.458402 6.159457 0 2.458578-.806671 4.538022-2.419992 6.240111-1.613331 1.675086-3.585175 2.514099-5.915534 2.514099-2.612051 0-4.737546-1.027366-6.376474-3.080682-1.331637-1.648053-1.997451-3.539154-1.997451-5.673528 0-2.107362.665814-3.985138 1.997451-5.633201 1.638928-2.053316 3.764423-3.080682 6.376474-3.080682z"
        />
      </Box>
    </Box>
    <Link
      component={NextLink}
      href={`${process.env.NEXT_PUBLIC_DOI_WEBSITE_URL}${articleDoi}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {`${process.env.NEXT_PUBLIC_DOI_WEBSITE_URL}${articleDoi}`}
    </Link>
  </Box>
);

export default ArticleDoi;
